import { values } from '@fortem-monorepo/js-utilities';
export const RETURN_TYPE = {
    TotalReturn: 'TR',
    ExcessReturn: 'ER',
    PriceReturn: 'PR',
};
export const RETURN_TYPES = values(RETURN_TYPE);
export const FUNDING_RETURN_TYPES = [RETURN_TYPE.TotalReturn, RETURN_TYPE.ExcessReturn];
export const FUNDED_RETURN_TYPES = [RETURN_TYPE.TotalReturn, RETURN_TYPE.PriceReturn];
